import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import {
  aboutURL,
  commingsoonURL,
  contactUsURL,
  homeURL,
  notFoundURL,
  productsURL,
  thankYouURL,
  privacyPolicyUrl,
  termsUrl,
  faqUrl,
  contactThankYouURL,
} from "./helpers/paths";
import ComingSoonNew from "./pages/ComingSoonNew/ComingSoonNew";
import Home from "./pages/Home/Home";
import Thankyou from "./pages/ThankYou/ThankYou";
import NotFoundV2 from "./pages/NotFoundV2/NotFoundV2";
import About from "./pages/About/About";
import HeaderV2 from "./components/HeaderV2/HeaderV2";
import FooterV2 from "./components/FooterV2/FooterV2";
import Products from "./pages/Products/Products";
import EnquireNow from "./components/EnquireNow/EnquireNow";
import ContactUs from "./pages/ContactUs/ContactUs";
import PrivacyPolicy from "./pages/PrivacyPolicy/PrivacyPolicy";
import Terms from "./pages/TermsConditions/Terms";
import Faq from "./pages/FAQs/Faq";
import { useLocation } from "react-router-dom";

const Routing = () => {
  const [enquireForm, setEnquireForm] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (
      location.pathname === thankYouURL ||
      location.pathname === notFoundURL ||
      location.pathname === contactThankYouURL
    ) {
      setEnquireForm(false);
    } else {
      setEnquireForm(true);
    }
  }, [location.pathname]);

  return (
    <>
      <HeaderV2 />
      <Routes>
        <Route exact path={homeURL} element={<Home />} />
        <Route exact path={aboutURL} element={<About />} />
        <Route exact path={commingsoonURL} element={<ComingSoonNew />} />
        <Route exact path={thankYouURL} element={<Thankyou />} />
        <Route exact path={contactThankYouURL} element={<Thankyou />} />
        <Route exact path={productsURL} element={<Products />} />
        <Route exact path={contactUsURL} element={<ContactUs />} />
        <Route exact path={privacyPolicyUrl} element={<PrivacyPolicy />} />
        <Route exact path={termsUrl} element={<Terms />} />
        {/* <Route exact path={faqUrl} element={<Faq />} /> */}
        <Route exact path={notFoundURL} element={<NotFoundV2 />} />
        <Route path="*" element={<Navigate to={notFoundURL} />} />
      </Routes>
      {enquireForm && (
        <>
          <EnquireNow />
          <FooterV2 />
        </>
      )}
    </>
  );
};

export default Routing;
